export default "__VITE_ASSET__CF98A6$B__"